import type { QueryClient } from "@tanstack/react-query";

/**
 * How long to wait before reconciling collection caches after a delete.
 *
 * Record-service writes are asynchronous twice over: the DELETE/PATCH returns
 * before the record writer commits, and collection lists (`POST /query`) are
 * served from the search projection, which trails the commit by another
 * moment. Refetching immediately therefore returns the PRE-write state —
 * deleted rows come back and edited cells revert until a manual reload.
 */
export const PROJECTION_SETTLE_MS = 2500;

/**
 * Refetch a read once the write has settled, and do nothing else.
 *
 * The floor every reconcile helper below is built on, and the whole story for a
 * read whose post-write value the frontend cannot compute — server-side rollups,
 * denormalized `edges.*` copies, a rename that has to travel through a
 * junction's dereference. There is nothing to write optimistically there, only a
 * refetch to postpone; postponing it is the point, because an immediate one
 * answers with pre-write state.
 */
export const settleInvalidate = (queryClient: QueryClient, queryKey: readonly unknown[]): void => {
  window.setTimeout(() => {
    void queryClient.invalidateQueries({ queryKey });
  }, PROJECTION_SETTLE_MS);
};
